module.exports = __webpack_public_path__ + "img/logo-app.73cf12ea.jpeg";